import lazyLoad from '@utils/lazyLoad'

const memberRoutes = [
  // 充值规则列表
  {
    path: '/recharge-mangement/recharge-rules',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/RuleMangement')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '储值规则',
      layoutMode: 'empty'
    }
  },
  {
    path: '/recharge-mangement/rule-edit/:brandId',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/RuleEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑规则'
    }
  },
  {
    path: '/recharge-mangement/card-rule-edit/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/CardRuleEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑规则'
    }
  },
  {
    path: '/recharge-mangement/card-rule-new/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/CardRuleEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新建规则'
    }
  },
  {
    path: '/recharge-mangement/recharge-activity-edit/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/ActivityEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '编辑活动'
    }
  },
  {
    path: '/recharge-mangement/recharge-activity-new/:id',
    exact: true,
    component: lazyLoad(() =>
      import('@views/Members/RechargeManagement/ActivityEdit')
    ),
    meta: {
      applicationCode: '7209ebc7-6536-469a-8a52-dac38de3f941',
      title: '新建活动'
    }
  }
]

export default memberRoutes
